import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Layout from "@/router/layouts/ClientReviewLayout.vue";
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { interpret } from "xstate";
import clientReviewMachines from "./machines/clientReviewMachines";
import ReviewComponent from "../reviews/components/ReviewComponent.vue";
import { PAReviewModule } from "@/store/modules/paReview.module";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
let ClientReview = /** @class */ (() => {
    let ClientReview = class ClientReview extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.machine = clientReviewMachines;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.tenantId = "";
            this.clientAssignmentId = "";
        }
        send(event) {
            this.machineService.send(event);
        }
        goToReview(stepId, reviewId) {
            PAReviewModule.IsOpenedByClient();
            let reviewComponent = this.$refs["reviewComponentRef"];
            reviewComponent.ShowReviewModal(reviewId, stepId, PAReviewModule.openedByClient);
        }
        handleModalClosed() {
            this.initialize(this.tenantId, this.clientAssignmentId);
        }
        get clientReview() {
            return PAReviewModule.clientReview;
        }
        initialize(tenantId, clientAssignmentId) {
            this.send({ type: "INITIALIZE", tenantId: tenantId, clientAssignmentId: clientAssignmentId });
        }
        CloseClientReview() {
            window.close();
        }
        DownloadPreviousReviewPdf(reviewId) {
            PAReviewModule.IsOpenedByClient();
            this.send({ type: "DOWNLOAD_PDF", previousReviewId: reviewId });
        }
        created() {
            this.tenantId = this.$route.params.tenantId;
            this.clientAssignmentId = this.$route.params.clientAssignmentId;
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.state = state;
                console.log(this.state.toStrings());
                if (this.state.matches("loadedClientReviews")) {
                    this.$bvModal.show("cycle-error-modal");
                }
            });
            this.initialize(this.tenantId, this.clientAssignmentId);
        }
        mounted() {
            // if (this.state.matches("loadedClientReviews")) {
            //     this.$bvModal.show("cycle-error-modal");
            // }
            //this.$refs.cycleErrorModal.show();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    ClientReview = __decorate([
        Component({
            name: "ClientReview",
            components: {
                Layout,
                Loader,
                ReviewComponent,
                SectionLoader,
            },
        })
    ], ClientReview);
    return ClientReview;
})();
export default ClientReview;
